<div id="dash-landing-wrapper">
  <div class="charts-wrapper">
    <div class="chart-list" [ngClass]="{'justify-content-center': isOnePeriod}">
      <div class="chart-group-items">
        <div class="chart-item purple">
          <div class="icon">
            <svg width="31" height="24" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M29.3287 7.86243C26.2716 3.23985 21.0521 0.42842 15.4313 0.37674C9.81064 0.42842 4.59118 3.23985 1.53401 7.86243C-0.0770912 10.1796 -0.0770912 13.2269 1.53401 15.5441C4.58946 20.1695 9.80922 22.9838 15.4314 23.0372C21.0521 22.9855 26.2716 20.1741 29.3288 15.5515C30.9433 13.2326 30.9433 10.1812 29.3287 7.86243ZM26.2005 13.4432C23.8664 17.0714 19.8078 19.2849 15.4313 19.3167C11.055 19.2849 6.99632 17.0714 4.66219 13.4432C3.93452 12.3955 3.93452 11.0184 4.66219 9.97074C6.99626 6.34259 11.0549 4.12906 15.4313 4.09726C19.8077 4.129 23.8664 6.34259 26.2005 9.97074C26.9282 11.0184 26.9282 12.3955 26.2005 13.4432Z" fill="white"/>
              <path d="M15.4312 16.6674C18.2268 16.6674 20.4931 14.4464 20.4931 11.7067C20.4931 8.96703 18.2268 6.74606 15.4312 6.74606C12.6357 6.74606 10.3694 8.96703 10.3694 11.7067C10.3694 14.4464 12.6357 16.6674 15.4312 16.6674Z" fill="white"/>
            </svg>
          </div>
          <div class="bottom-wrapper">
            <div class="amount-wrapper">
              <span class="value">
                {{this.periodsCounters.views[0]}}
              </span>
              <span class="simbol">

              </span>
            </div>
            <div class="status-wrapper">
              <span class="value">
                views
              </span>
            </div>
          </div>
      </div>
      <div class="chart-item azure" *ngIf="!isOnePeriod">

        <div class="icon">
          <svg width="31" height="24" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.3287 7.86243C26.2716 3.23985 21.0521 0.42842 15.4313 0.37674C9.81064 0.42842 4.59118 3.23985 1.53401 7.86243C-0.0770912 10.1796 -0.0770912 13.2269 1.53401 15.5441C4.58946 20.1695 9.80922 22.9838 15.4314 23.0372C21.0521 22.9855 26.2716 20.1741 29.3288 15.5515C30.9433 13.2326 30.9433 10.1812 29.3287 7.86243ZM26.2005 13.4432C23.8664 17.0714 19.8078 19.2849 15.4313 19.3167C11.055 19.2849 6.99632 17.0714 4.66219 13.4432C3.93452 12.3955 3.93452 11.0184 4.66219 9.97074C6.99626 6.34259 11.0549 4.12906 15.4313 4.09726C19.8077 4.129 23.8664 6.34259 26.2005 9.97074C26.9282 11.0184 26.9282 12.3955 26.2005 13.4432Z" fill="white"/>
            <path d="M15.4312 16.6674C18.2268 16.6674 20.4931 14.4464 20.4931 11.7067C20.4931 8.96703 18.2268 6.74606 15.4312 6.74606C12.6357 6.74606 10.3694 8.96703 10.3694 11.7067C10.3694 14.4464 12.6357 16.6674 15.4312 16.6674Z" fill="white"/>
          </svg>
        </div>
        <div class="bottom-wrapper">
          <div class="amount-wrapper">
            <span class="value">
              {{this.periodsCounters.views[1]}}

            </span>
            <span class="simbol">

            </span>
          </div>
          <div class="status-wrapper">
            <span class="value">
              views
            </span>
          </div>
        </div>
      </div>
      </div>


      <div class="chart-group-items">
        <div class="chart-item purple">

          <div class="icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.33333 28C6.44928 28 5.60143 27.6488 4.97631 27.0237C4.35119 26.3986 4 25.5507 4 24.6667V2C4 1.46957 3.78929 0.960859 3.41421 0.585786C3.03914 0.210714 2.53043 0 2 0V0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 24.6667C0 26.6116 0.772617 28.4769 2.14788 29.8521C3.52315 31.2274 5.38841 32 7.33333 32H30C30.5304 32 31.0391 31.7893 31.4142 31.4142C31.7893 31.0391 32 30.5304 32 30C32 29.4696 31.7893 28.9609 31.4142 28.5858C31.0391 28.2107 30.5304 28 30 28H7.33333Z" fill="white"/>
              <path d="M26 24C26.5304 24 27.0391 23.7893 27.4142 23.4142C27.7893 23.0391 28 22.5304 28 22V14C28 13.4696 27.7893 12.9609 27.4142 12.5858C27.0391 12.2107 26.5304 12 26 12C25.4696 12 24.9609 12.2107 24.5858 12.5858C24.2107 12.9609 24 13.4696 24 14V22C24 22.5304 24.2107 23.0391 24.5858 23.4142C24.9609 23.7893 25.4696 24 26 24Z" fill="white"/>
              <path d="M10 24C10.5304 24 11.0391 23.7893 11.4142 23.4142C11.7893 23.0391 12 22.5304 12 22V14C12 13.4696 11.7893 12.9609 11.4142 12.5858C11.0391 12.2107 10.5304 12 10 12C9.46957 12 8.96086 12.2107 8.58579 12.5858C8.21071 12.9609 8 13.4696 8 14V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24Z" fill="white"/>
              <path d="M18 23.9992C18.5304 23.9992 19.0391 23.7884 19.4142 23.4134C19.7893 23.0383 20 22.5296 20 21.9992V7.33249C20 6.80206 19.7893 6.29335 19.4142 5.91828C19.0391 5.5432 18.5304 5.33249 18 5.33249C17.4696 5.33249 16.9609 5.5432 16.5858 5.91828C16.2107 6.29335 16 6.80206 16 7.33249V21.9992C16 22.5296 16.2107 23.0383 16.5858 23.4134C16.9609 23.7884 17.4696 23.9992 18 23.9992Z" fill="white"/>
              </svg>
          </div>
          <div class="bottom-wrapper">
            <div class="amount-wrapper">
              <span class="value">
                {{this.periodsCounters.completed[0]}}

              </span>
              <span class="simbol">

              </span>
            </div>
            <div class="status-wrapper">
              <span class="value">
                Completed surveys
              </span>
            </div>
          </div>
        </div>
        <div class="chart-item azure" *ngIf="!isOnePeriod">

          <div class="icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.33333 28C6.44928 28 5.60143 27.6488 4.97631 27.0237C4.35119 26.3986 4 25.5507 4 24.6667V2C4 1.46957 3.78929 0.960859 3.41421 0.585786C3.03914 0.210714 2.53043 0 2 0V0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 24.6667C0 26.6116 0.772617 28.4769 2.14788 29.8521C3.52315 31.2274 5.38841 32 7.33333 32H30C30.5304 32 31.0391 31.7893 31.4142 31.4142C31.7893 31.0391 32 30.5304 32 30C32 29.4696 31.7893 28.9609 31.4142 28.5858C31.0391 28.2107 30.5304 28 30 28H7.33333Z" fill="white"/>
              <path d="M26 24C26.5304 24 27.0391 23.7893 27.4142 23.4142C27.7893 23.0391 28 22.5304 28 22V14C28 13.4696 27.7893 12.9609 27.4142 12.5858C27.0391 12.2107 26.5304 12 26 12C25.4696 12 24.9609 12.2107 24.5858 12.5858C24.2107 12.9609 24 13.4696 24 14V22C24 22.5304 24.2107 23.0391 24.5858 23.4142C24.9609 23.7893 25.4696 24 26 24Z" fill="white"/>
              <path d="M10 24C10.5304 24 11.0391 23.7893 11.4142 23.4142C11.7893 23.0391 12 22.5304 12 22V14C12 13.4696 11.7893 12.9609 11.4142 12.5858C11.0391 12.2107 10.5304 12 10 12C9.46957 12 8.96086 12.2107 8.58579 12.5858C8.21071 12.9609 8 13.4696 8 14V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24Z" fill="white"/>
              <path d="M18 23.9992C18.5304 23.9992 19.0391 23.7884 19.4142 23.4134C19.7893 23.0383 20 22.5296 20 21.9992V7.33249C20 6.80206 19.7893 6.29335 19.4142 5.91828C19.0391 5.5432 18.5304 5.33249 18 5.33249C17.4696 5.33249 16.9609 5.5432 16.5858 5.91828C16.2107 6.29335 16 6.80206 16 7.33249V21.9992C16 22.5296 16.2107 23.0383 16.5858 23.4134C16.9609 23.7884 17.4696 23.9992 18 23.9992Z" fill="white"/>
              </svg>
          </div>
          <div class="bottom-wrapper">
            <div class="amount-wrapper">
              <span class="value">
                {{this.periodsCounters.completed[1]}}
              </span>
              <span class="simbol">

              </span>
            </div>
            <div class="status-wrapper">
              <span class="value">
                Completed surveys
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-group-items">
        <div class="chart-item purple">

          <div class="icon">
            <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.84891 30C7.86279 29.9956 6.90339 29.6796 6.10837 29.0973C5.29591 28.5269 4.68966 27.71 4.3798 26.7681C4.06993 25.8261 4.07302 24.8096 4.38858 23.8695L5.90034 19.2027L1.92067 16.2986C1.12273 15.7168 0.529622 14.898 0.226216 13.9593C-0.0771908 13.0207 -0.075351 12.0103 0.231472 11.0728C0.538295 10.1352 1.13438 9.31859 1.93444 8.73965C2.7345 8.1607 3.69754 7.84914 4.68577 7.84954H9.55699L11.0364 3.24588C11.3401 2.30314 11.9357 1.48091 12.7375 0.8976C13.5393 0.314288 14.5059 0 15.4981 0C16.4903 0 17.4569 0.314288 18.2587 0.8976C19.0605 1.48091 19.6561 2.30314 19.9597 3.24588V3.24588L21.4443 7.84954H26.3155C27.3036 7.84942 28.2665 8.16117 29.0663 8.74021C29.8662 9.31926 30.4621 10.1359 30.7687 11.0734C31.0754 12.0109 31.0771 13.0211 30.7737 13.9596C30.4702 14.8981 29.8772 15.7168 29.0793 16.2986L25.101 19.2027L26.6127 23.8695C26.9175 24.8109 26.9153 25.8245 26.6063 26.7645C26.2974 27.7046 25.6977 28.5226 24.8934 29.1009C24.0892 29.6793 23.1219 29.9881 22.1306 29.9831C21.1393 29.978 20.1752 29.6593 19.3769 29.0728L15.5006 26.2281L11.6243 29.0741C10.8223 29.6711 9.84949 29.9957 8.84891 30V30ZM4.68577 11.7182C4.51522 11.7182 4.34903 11.7719 4.21094 11.8718C4.07286 11.9717 3.96995 12.1126 3.91692 12.2744C3.86389 12.4362 3.86346 12.6106 3.91568 12.7726C3.9679 12.9346 4.07011 13.0761 4.20769 13.1766L9.31924 16.9047C9.64838 17.1449 9.89324 17.4826 10.019 17.8697C10.1447 18.2568 10.1449 18.6736 10.0196 19.0608L8.08141 25.0572C8.02762 25.2198 8.02707 25.3953 8.07983 25.5583C8.1326 25.7213 8.23593 25.8633 8.3749 25.9638C8.51387 26.0643 8.68127 26.1181 8.85289 26.1174C9.02451 26.1167 9.19145 26.0615 9.32958 25.9599L14.3546 22.2705C14.6874 22.026 15.0899 21.8942 15.5032 21.8942C15.9165 21.8942 16.319 22.026 16.6519 22.2705L21.6769 25.9586C21.8148 26.0612 21.982 26.1171 22.1541 26.1183C22.3261 26.1194 22.494 26.0657 22.6333 25.965C22.7726 25.8642 22.8761 25.7217 22.9285 25.5582C22.981 25.3947 22.9798 25.2187 22.9251 25.0559L20.9869 19.0595C20.8615 18.6723 20.8618 18.2555 20.9875 17.8684C21.1132 17.4813 21.3581 17.1436 21.6872 16.9034L26.7975 13.1754C26.935 13.0748 27.0371 12.9335 27.0894 12.7716C27.1416 12.6097 27.1413 12.4355 27.0884 12.2737C27.0356 12.112 26.9329 11.9711 26.795 11.8711C26.6571 11.7711 26.4911 11.7171 26.3207 11.7169H20.023C19.6125 11.7168 19.2126 11.5866 18.881 11.3451C18.5494 11.1036 18.3032 10.7633 18.1779 10.3732L16.2759 4.4271C16.2235 4.26436 16.1207 4.12241 15.9823 4.02171C15.8439 3.92101 15.6771 3.86675 15.5058 3.86675C15.3345 3.86675 15.1677 3.92101 15.0293 4.02171C14.8909 4.12241 14.7881 4.26436 14.7357 4.4271L12.8195 10.3745C12.6944 10.764 12.4488 11.1038 12.118 11.3453C11.7871 11.5867 11.3881 11.7173 10.9783 11.7182H4.68577Z" fill="white"/>
            </svg>
          </div>
          <div class="bottom-wrapper">
            <div class="amount-wrapper">
              <span class="value">
              {{this.periodsCounters?.nps?.data[0].nps_value| number : '1.1-1'}}
              </span>

            </div>
            <div class="status-wrapper">
              <span class="value">
                N.P.S
              </span>
            </div>
          </div>
        </div>
        <div class="chart-item azure" *ngIf="!isOnePeriod">

          <div class="icon">
            <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.84891 30C7.86279 29.9956 6.90339 29.6796 6.10837 29.0973C5.29591 28.5269 4.68966 27.71 4.3798 26.7681C4.06993 25.8261 4.07302 24.8096 4.38858 23.8695L5.90034 19.2027L1.92067 16.2986C1.12273 15.7168 0.529622 14.898 0.226216 13.9593C-0.0771908 13.0207 -0.075351 12.0103 0.231472 11.0728C0.538295 10.1352 1.13438 9.31859 1.93444 8.73965C2.7345 8.1607 3.69754 7.84914 4.68577 7.84954H9.55699L11.0364 3.24588C11.3401 2.30314 11.9357 1.48091 12.7375 0.8976C13.5393 0.314288 14.5059 0 15.4981 0C16.4903 0 17.4569 0.314288 18.2587 0.8976C19.0605 1.48091 19.6561 2.30314 19.9597 3.24588V3.24588L21.4443 7.84954H26.3155C27.3036 7.84942 28.2665 8.16117 29.0663 8.74021C29.8662 9.31926 30.4621 10.1359 30.7687 11.0734C31.0754 12.0109 31.0771 13.0211 30.7737 13.9596C30.4702 14.8981 29.8772 15.7168 29.0793 16.2986L25.101 19.2027L26.6127 23.8695C26.9175 24.8109 26.9153 25.8245 26.6063 26.7645C26.2974 27.7046 25.6977 28.5226 24.8934 29.1009C24.0892 29.6793 23.1219 29.9881 22.1306 29.9831C21.1393 29.978 20.1752 29.6593 19.3769 29.0728L15.5006 26.2281L11.6243 29.0741C10.8223 29.6711 9.84949 29.9957 8.84891 30V30ZM4.68577 11.7182C4.51522 11.7182 4.34903 11.7719 4.21094 11.8718C4.07286 11.9717 3.96995 12.1126 3.91692 12.2744C3.86389 12.4362 3.86346 12.6106 3.91568 12.7726C3.9679 12.9346 4.07011 13.0761 4.20769 13.1766L9.31924 16.9047C9.64838 17.1449 9.89324 17.4826 10.019 17.8697C10.1447 18.2568 10.1449 18.6736 10.0196 19.0608L8.08141 25.0572C8.02762 25.2198 8.02707 25.3953 8.07983 25.5583C8.1326 25.7213 8.23593 25.8633 8.3749 25.9638C8.51387 26.0643 8.68127 26.1181 8.85289 26.1174C9.02451 26.1167 9.19145 26.0615 9.32958 25.9599L14.3546 22.2705C14.6874 22.026 15.0899 21.8942 15.5032 21.8942C15.9165 21.8942 16.319 22.026 16.6519 22.2705L21.6769 25.9586C21.8148 26.0612 21.982 26.1171 22.1541 26.1183C22.3261 26.1194 22.494 26.0657 22.6333 25.965C22.7726 25.8642 22.8761 25.7217 22.9285 25.5582C22.981 25.3947 22.9798 25.2187 22.9251 25.0559L20.9869 19.0595C20.8615 18.6723 20.8618 18.2555 20.9875 17.8684C21.1132 17.4813 21.3581 17.1436 21.6872 16.9034L26.7975 13.1754C26.935 13.0748 27.0371 12.9335 27.0894 12.7716C27.1416 12.6097 27.1413 12.4355 27.0884 12.2737C27.0356 12.112 26.9329 11.9711 26.795 11.8711C26.6571 11.7711 26.4911 11.7171 26.3207 11.7169H20.023C19.6125 11.7168 19.2126 11.5866 18.881 11.3451C18.5494 11.1036 18.3032 10.7633 18.1779 10.3732L16.2759 4.4271C16.2235 4.26436 16.1207 4.12241 15.9823 4.02171C15.8439 3.92101 15.6771 3.86675 15.5058 3.86675C15.3345 3.86675 15.1677 3.92101 15.0293 4.02171C14.8909 4.12241 14.7881 4.26436 14.7357 4.4271L12.8195 10.3745C12.6944 10.764 12.4488 11.1038 12.118 11.3453C11.7871 11.5867 11.3881 11.7173 10.9783 11.7182H4.68577Z" fill="white"/>
            </svg>
          </div>
          <div class="bottom-wrapper">
            <div class="amount-wrapper">
              <span class="value">
                {{this.periodsCounters?.nps?.data[1].nps_value| number : '1.1-1'}}

              </span>

            </div>
            <div class="status-wrapper">
              <span class="value">
                N.P.S
              </span>
            </div>
          </div>
        </div>
      </div>
      </div>
  </div>

  <div class="base--form-generic" style="min-height: unset;">
    <div class="fields-wrapper justify-content-end">
      <div class="form-group">
        <div class="form-row">
          <div class="form-column">
            <div class="btn-default slim white" (click)="toggleModalKeys()" >
              Show survey
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row p-0">
      <div echarts [options]="chartOption" class="completed-chart"></div>
      <div echarts [options]="chartAccumulateOption" class="accumulate-chart"></div>
  </div>

  <!-- <ng-container *ngIf="showModalKeys" >
    <div class="modal-keys">
      <section>
          <div class="top-wrapper">
            <button class="modal-close"type="button" (click)="toggleModalKeys()">X</button>
          </div>
          <table>
            <thead>
              <tr>
                <th align="center">TOUCHPOINT</th>
                <th align="center">ID</th>
                <th align="center" style="width: 75%;">DOMANDA</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let question of questions" >
                <tr>
                  <td align="center">{{question.touch_point}}</td>
                  <td align="center" >{{question.domanda_id}}</td>
                  <td style="width: 70%;" align="center" >{{question.description}}</td>
                </tr>
              </ng-container>

            </tbody>

          </table>
      </section>
    </div>

  </ng-container> -->
</div>
